module.exports = __webpack_public_path__ + "archivist_badge_04.jpg?02a7bfb9795c8b7a6d313d40b450a2db";


//////////////////
// WEBPACK FOOTER
// ./src/img/badge/archivist_badge_04.jpg
// module id = 379
// module chunks = 0